import React, { useState, useEffect } from 'react';
import RegistroUsuariosView from './RegistroUsuariosView';
import { useHistory } from 'react-router-dom';
import { useFormik } from "formik";
import { registroSchemaUsuarios } from './registro.schema';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { UseRegistroUsuario } from '../../../services/Registro';

const RegistroUsuario = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        state: false,
        message: ""
    });
    const [terminos_y_condiciones, acepto_terminos_y_condiciones] = useState(false);

    const validacion_de_usuario = async (nombre, apellido, email, password, terminos_y_condiciones) => {
        UseRegistroUsuario(nombre, apellido, email, password, terminos_y_condiciones)
    };

    const formik = useFormik({
        initialValues: {
            nombre: "",
            apellido: "",
            email: "",
            password: ""
        },
        validationSchema: registroSchemaUsuarios,

        onSubmit: async (values) => {


            const usuario_valido = await validacion_de_usuario(
                formik.values.nombre,
                formik.values.apellido,
                formik.values.email,
                formik.values.password,
                terminos_y_condiciones,
            )
            console.log(usuario_valido)
        }
    });

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    return (
        <RegistroUsuariosView
            formik={formik}
            loading={loading}
            error={error}
            terminos_y_condiciones={terminos_y_condiciones}
            acepto_terminos_y_condiciones={acepto_terminos_y_condiciones}
        />
    )
}

export default RegistroUsuario;
